export const XSRF_REFRESH_URL = '/api/xsrf'
